/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-nested-ternary */
import { t } from 'i18next';

import { SelectionCardProps } from '../../../molecules/selection-card/selection-card';

interface AnswerProps extends SelectionCardProps {
  details: SelectionCardProps['details'] & {
    minMax?: {
      min: number;
      max: number;
    };
  };
}
export const createAnswers = (
  answerGroup: 'age' | 'gender' | 'how' | 'region',
  values: Record<string, any>[],
): AnswerProps[] => {
  const translationKey = `help-me:${answerGroup}Answers.`;
  const answers = values.map((value) => ({
    ariaLabel: t(`${translationKey}${value.label}AriaLabel`),
    details: {
      value: value.value,
      image: {
        alt: t(`${translationKey}${value.label}Alt`),
        url: value.imageUrl,
      },
      label: t(`${translationKey}${value.label}`),
      primaryText:
        answerGroup === 'gender' || answerGroup === 'region'
          ? undefined
          : answerGroup === 'age'
            ? t(`${translationKey}${value.label}`)
            : t(`${translationKey}${value.label}PrimaryText`),
      ...(answerGroup === 'age' && {
        primaryBody: t(`${translationKey}${value.label}PrimaryBody`),
      }),
      ...((answerGroup === 'gender' || answerGroup === 'region') && {
        primaryBody: t(`${translationKey}${value.label}`),
      }),
      secondaryTitle:
        answerGroup === 'age' ||
        answerGroup === 'gender' ||
        answerGroup === 'region'
          ? t(`${translationKey}${value.label}`)
          : t(`${translationKey}${value.label}SecondaryTitle`),
      secondaryText: t(`${translationKey}${value.label}SecondaryText`),
      ...(answerGroup === 'age' && {
        tinyTopText: t(`${translationKey}${value.label}TopText`),
      }),
      ...(answerGroup === 'age' && {
        minMax: {
          min: value.min,
          max: value.max,
        },
      }),
    },
  }));

  return answers;
};
